import { cn } from "@/lib/utils";

export const SectionHeading = ({
  kicker,
  title,
  subtitle,
  align = "left",
  tone = "light",
  className,
}) => {
  const titleColor = tone === "navy" ? "text-white" : "text-[var(--ibp-ink)]";
  const subColor =
    tone === "navy"
      ? "text-white/70"
      : "text-[color:rgba(11,18,32,0.65)]";
  const kickerColor = tone === "navy" ? "text-[#E7BE4A]" : "text-[#B7791F]";
  return (
    <div
      className={cn(
        align === "center" && "mx-auto max-w-2xl text-center",
        className
      )}
    >
      {kicker && (
        <p
          className={cn(
            "text-xs font-semibold uppercase tracking-[0.18em]",
            kickerColor
          )}
        >
          {kicker}
        </p>
      )}
      <h2
        className={cn(
          "mt-3 font-[var(--font-heading)] text-3xl leading-tight tracking-[-0.02em] sm:text-4xl",
          titleColor
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={cn("mt-4 text-base leading-7", subColor)}>{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
